import { useMutation, useQueryClient } from "react-query";

import { addArticle, editArticle } from "./index";

export const useAddArticle = () => {
  const queryClient = useQueryClient();

  return useMutation(["add-article"], addArticle, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-articles-list"] });
    },
  });
};

export const useEditArticle = () => {
  const queryClient = useQueryClient();

  return useMutation(["edit-article"], editArticle, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-articles-list"] });
    },
  });
};
